import { Col, Row } from "antd";
import React from "react";
import { Loading } from "../../../../component/loading";
import lodash from "lodash";
import IncomeStaffCompletedTable from "./component/income_staff_completed_table";

const IncomeStaffCompleted = (props) => {
  // -------------------------- VAR --------------------------
  const { loading, jobs, userList } = props;
  const jobList = jobs?.filter((job) => {
    const totalIncome = lodash.sumBy(job?.staffs, (staff) => staff?.value);
    return job?.status !== "0" && totalIncome === job?.subtotal;
  });
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderCompletedList = () => {
    if (loading) {
      return (
        <Col span={24} align="center">
          <Loading />
        </Col>
      );
    } else {
      return <IncomeStaffCompletedTable jobList={jobList} userList={userList} />;
    }
  };

  // -------------------------- MAIN --------------------------
  return (
    <Col span={24}>
      <Row gutter={[20, 20]}>
        <Col span={24}>{renderCompletedList()}</Col>
      </Row>
    </Col>
  );
};
export default IncomeStaffCompleted;